var EmailItemBase = require("./EmailItemBase");
var EmailItem = xClass("EmailItem", EmailItemBase, function () {
    return cc.CSLoader.createNode("cocos/mail_mail_energy.csb");
})

EmailItem.prototype.ctor = function () {
    var self = this;
    EmailItemBase.prototype.ctor.call(self);
}

EmailItem.prototype.initData = function (data) {
    let self = this;
    EmailItemBase.prototype.initData.call(self, data);
    let title = data.senderName;
    if (title.length > 7) {
        title = title.slice(0, 7) + "...";
    }
    self.title.setString(title);
}

EmailItem.prototype.onClickAccept = function () {
    let self = this;
    const mailId = self.data.mailId;
    self.EmailMgr.mailAccept(mailId).then(function (evt) {
        self.EmailMgr.isBusy = false;
        //
        let rewards = evt.rewards;
        ActivityGetRewardsPanel.show({
            type: 1,
            add_model: "mail",
            rewardList: rewards,
            tobagAni: true,
            title: "normal",
            closeCb: () => {
            }
        })
        //
        let reward = "";
        table.each(rewards, function (item) {
            if (item) {
                reward += item.itemId + "_" + item.num + ";";
            }
        })
        self.EmailMgr.dcSimple("page_click", {
            click_type: "energy",
            session: self.EmailMgr.dcSession,
            sub_id: mailId,
            s_time: self.EmailMgr.getDcSTime(self.data.expireTs),
            reward,
        });
        //
        self.EmailMgr.delMail(mailId);
        self.EmailMgr.refreshMails();
    }).catch(function (err) {
        console.error("EmailItemEnergy", err);
        self.EmailMgr.isBusy = false;
    });

}

module.exports = EmailItem;
